module.exports = __webpack_public_path__ + "img/gb1021.prt.c28d5f98.jpg";